(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-lp-keepsup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.apexkeep').forEach(function (section) {
        var track = section.querySelector('[data-apexkeep-track]');
        var arrows = section.querySelectorAll('.apexkeep__acc-arrow');
        if (!track || !arrows.length) return;

        function step() {
          var tile = track.querySelector('.apexkeep__acc');
          return tile ? tile.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
        }

        function updateArrows() {
          var maxScroll = track.scrollWidth - track.clientWidth - 1;
          arrows.forEach(function (btn) {
            if (btn.getAttribute('data-apexkeep-dir') === 'prev') {
              btn.disabled = track.scrollLeft <= 1;
            } else {
              btn.disabled = track.scrollLeft >= maxScroll;
            }
          });
        }

        arrows.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var dir = btn.getAttribute('data-apexkeep-dir') === 'next' ? 1 : -1;
            track.scrollBy({ left: dir * step(), behavior: 'smooth' });
          });
        });

        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drops-current"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.dcurr').forEach(function (section) {
      var track = section.querySelector('[data-dcurr-track]');
      var arrows = section.querySelectorAll('[data-dcurr-dir]');
      if (!track || !arrows.length) return;

      function isMobile() { return window.innerWidth < 750; }

      function scrollAmt() {
        var card = track.querySelector('.dcurr__card');
        if (!card) return 300;
        return card.offsetWidth + (parseInt(getComputedStyle(track).gap) || 0);
      }

      function updateArrows() {
        if (!isMobile()) {
          arrows.forEach(function (a) { a.disabled = false; });
          return;
        }
        var max = track.scrollWidth - track.clientWidth - 1;
        arrows.forEach(function (a) {
          a.disabled = a.dataset.dcurrDir === 'prev'
            ? track.scrollLeft <= 1
            : track.scrollLeft >= max;
        });
      }

      arrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!isMobile()) return;
          var dir = btn.dataset.dcurrDir === 'next' ? 1 : -1;
          track.scrollBy({ left: dir * scrollAmt(), behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drops-upcoming"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.dupc').forEach(function (section) {
      var track = section.querySelector('[data-dupc-track]');
      var arrows = section.querySelectorAll('[data-dupc-dir]');
      if (!track || !arrows.length) return;

      function isMobile() { return window.innerWidth < 750; }

      function scrollAmt() {
        var card = track.querySelector('.dupc__card');
        if (!card) return 300;
        return card.offsetWidth + (parseInt(getComputedStyle(track).gap) || 0);
      }

      function updateArrows() {
        if (!isMobile()) {
          arrows.forEach(function (a) { a.disabled = false; });
          return;
        }
        var max = track.scrollWidth - track.clientWidth - 1;
        arrows.forEach(function (a) {
          a.disabled = a.dataset.dupcDir === 'prev'
            ? track.scrollLeft <= 1
            : track.scrollLeft >= max;
        });
      }

      arrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!isMobile()) return;
          var dir = btn.dataset.dupcDir === 'next' ? 1 : -1;
          track.scrollBy({ left: dir * scrollAmt(), behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-build-sheet"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hotspot-build-sheet')) {
  class HotspotBuildSheet extends HTMLElement {
    connectedCallback() {
      this.pins = Array.from(this.querySelectorAll('[data-hbs-pin]'));
      this.rows = Array.from(this.querySelectorAll('[data-hbs-row]'));
      this.visual = this.querySelector('.hbs__visual');

      this.pins.forEach((pin) => {
        pin.addEventListener('click', () => {
          this.select(pin.dataset.hbsPin, { scroll: true });
        });
      });

      this.rows.forEach((row) => {
        const toggle = row.querySelector('[data-hbs-toggle]');
        if (!toggle) return;
        toggle.addEventListener('click', () => {
          const isOpen = row.classList.contains('is-open');
          this.select(isOpen ? null : row.dataset.hbsRow);
        });
      });

      this.setupBundleForm();
      this.syncPins();

      this.onResize = this.onResize.bind(this);
      this.remeasure = this.scheduleMeasure.bind(this);
      this.scheduleMeasure();
      this.watchSectionVisibility();
      this.liftConsentButton();
      this.setupRailProgress();
      // Re-measure once webfonts have settled and the bar's height is final. If
      // load already fired before this element upgraded, that listener would
      // never run — so measure again on the next frame instead.
      if (document.readyState === 'complete') {
        requestAnimationFrame(this.remeasure);
      } else {
        window.addEventListener('load', this.remeasure);
      }
      window.addEventListener('resize', this.onResize);
      window.addEventListener('orientationchange', this.remeasure);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.measureFrame);
      cancelAnimationFrame(this.railFrame);
      if (this.barObserver) this.barObserver.disconnect();
      if (this.rail && this.onRailScroll) this.rail.removeEventListener('scroll', this.onRailScroll);
      window.removeEventListener('load', this.remeasure);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('orientationchange', this.remeasure);
    }

    onResize() {
      // Ignore height-only resizes — on mobile those are just the URL bar
      // collapsing, and re-measuring on them jumps the content mid-scroll.
      if (window.innerWidth === this.measuredWidth) return;
      this.scheduleMeasure();
    }

    scheduleMeasure() {
      this.measuredWidth = window.innerWidth;
      // Measure on the next frame: reading layout inside a resize handler can
      // catch a mid-reflow value.
      cancelAnimationFrame(this.measureFrame);
      this.measureFrame = requestAnimationFrame(() => {
        this.measureBar();
        this.updateRailProgress();
      });
    }

    setupRailProgress() {
      this.rail = this.querySelector('.hbs__setups-rail');
      this.railProgress = this.querySelector('[data-hbs-rail-progress]');
      if (!this.rail || !this.railProgress) return;

      this.onRailScroll = () => {
        if (this.railFrame) return;
        this.railFrame = requestAnimationFrame(() => {
          this.railFrame = 0;
          this.updateRailProgress();
        });
      };
      this.rail.addEventListener('scroll', this.onRailScroll, { passive: true });
      this.updateRailProgress();
    }

    // Thumb spans the visible fraction of the rail and sits at the scrolled
    // fraction, so a short thumb is itself the cue that there's more to scroll.
    updateRailProgress() {
      if (!this.rail || !this.railProgress) return;

      const scrollable = this.rail.scrollWidth - this.rail.clientWidth;
      // Don't imply there's more when everything already fits.
      if (scrollable < 2) {
        this.railProgress.hidden = true;
        return;
      }

      this.railProgress.hidden = false;
      const visible = (this.rail.clientWidth / this.rail.scrollWidth) * 100;
      const at = (this.rail.scrollLeft / this.rail.scrollWidth) * 100;
      this.railProgress.style.setProperty('--hbs-rail-thumb', visible + '%');
      this.railProgress.style.setProperty('--hbs-rail-pos', at + '%');
    }

    // The bar is fixed on mobile, so its height has to be reserved in the flow.
    measureBar() {
      const bar = this.querySelector('.hbs__bar');
      if (!bar) return;
      const height = Math.round(bar.getBoundingClientRect().height);
      if (height <= 0) return;

      this.style.setProperty('--hbs-bar-height', height + 'px');
      this.syncConsentButton();
    }

    // The cookie-consent reopen button sits bottom-left, exactly where the fixed
    // bar is. It lives inside an open shadow root on <csm-cookie-consent> with its
    // own position:fixed, so no page-level CSS can touch it — the only way to
    // move it is a rule inside that shadow root. Custom properties do inherit
    // across the boundary, so the offset itself stays driven from out here.
    liftConsentButton(attempt) {
      const host = document.querySelector('csm-cookie-consent');
      const root = host && host.shadowRoot;

      if (!root) {
        // The app boots asynchronously; retry briefly, then give up quietly.
        const next = (attempt || 0) + 1;
        if (next <= 20) setTimeout(() => this.liftConsentButton(next), 500);
        return;
      }

      if (root.getElementById('hbs-consent-offset')) return;

      const style = document.createElement('style');
      style.id = 'hbs-consent-offset';
      // The wrapper's own class is app-generated, so match it by the button it
      // contains. !important because the wrapper carries inline styles.
      style.textContent =
        'div:has(> #reopen_widget),div:has(> .isense-reopen-widget-icon){'
        + 'opacity:var(--hbs-consent-opacity,1)!important;'
        + 'visibility:var(--hbs-consent-visibility,visible)!important;'
        + 'transition:opacity .2s ease,visibility .2s ease}';
      root.appendChild(style);
    }

    // On a phone there is nowhere for the button to sit that isn't either the buy
    // bar or the panel heading, so hold it back until the section is scrolled
    // past. It still shows on the rest of this page and everywhere else on the
    // site. Desktop is untouched — the button and the panel don't collide there.
    syncConsentButton() {
      const mobile = window.matchMedia('(max-width: 1067px)').matches;
      const scrolledPast = this.classList.contains('hbs--bar-hidden');
      const root = document.documentElement.style;

      // Fail open: without the observer nothing would ever reveal it again, and
      // leaving a consent control permanently hidden is not acceptable.
      if (mobile && !scrolledPast && this.barObserver) {
        root.setProperty('--hbs-consent-opacity', '0');
        root.setProperty('--hbs-consent-visibility', 'hidden');
        return;
      }

      root.removeProperty('--hbs-consent-opacity');
      root.removeProperty('--hbs-consent-visibility');
    }

    // Tracks whether the section is on screen: hides the fixed bar so it can't
    // sit over the footer, and gates the consent button. Runs even without a
    // bundle bar, because the consent button depends on it either way.
    watchSectionVisibility() {
      if (typeof IntersectionObserver === 'undefined') return;
      this.barObserver = new IntersectionObserver((entries) => {
        // Several records can be queued into one callback — the last is current.
        const latest = entries[entries.length - 1];
        this.classList.toggle('hbs--bar-hidden', !latest.isIntersecting);
        this.syncConsentButton();
      }, { threshold: 0 });
      this.barObserver.observe(this);
    }

    select(index, options) {
      const opts = options || {};
      this.rows.forEach((row) => {
        const isTarget = index !== null && row.dataset.hbsRow === String(index);
        const body = row.querySelector('.hbs__row-body');
        const toggle = row.querySelector('[data-hbs-toggle]');

        row.classList.toggle('is-open', isTarget);
        if (toggle) toggle.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
        if (body) body.inert = !isTarget;

        if (isTarget && opts.scroll) this.scrollToRow(row);
      });
      this.syncPins(index);
    }

    syncPins(index) {
      const active = index === undefined
        ? (this.rows.find((row) => row.classList.contains('is-open')) || {}).dataset
        : { hbsRow: index === null ? null : String(index) };

      this.pins.forEach((pin) => {
        const isActive = !!active && active.hbsRow === pin.dataset.hbsPin;
        pin.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    scrollToRow(row) {
      // Clear whatever is pinned above the row: the shot when it's sticky
      // (desktop) and the theme's header when it is too.
      let offset = 12;

      if (this.visual) {
        const position = getComputedStyle(this.visual).position;
        if (position === 'sticky' || position === 'fixed') {
          offset += this.visual.getBoundingClientRect().height;
        }
      }

      const header = document.querySelector('.header-sticky--active');
      if (header) offset += header.getBoundingClientRect().height;

      const bar = this.querySelector('.hbs__bar');
      const barClearance = bar && getComputedStyle(bar).position === 'fixed'
        ? bar.getBoundingClientRect().height
        : 0;

      // Don't jump the page when the row is already comfortably in view — on
      // desktop the whole panel usually is.
      const rect = row.getBoundingClientRect();
      if (rect.top >= offset && rect.bottom <= window.innerHeight - barClearance) return;

      const top = rect.top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    setupBundleForm() {
      this.bundleForm = this.querySelector('[data-hbs-bundle-form]');
      if (!this.bundleForm) return;
      this.bundleError = this.querySelector('[data-hbs-bundle-error]');
      this.bundleForm.addEventListener('submit', this.onBundleSubmit.bind(this));
      this.setupPicker();
    }

    setupPicker() {
      const picker = this.querySelector('[data-hbs-picker]');
      // No <dialog> support (Safari < 15.4): fall back to adding the defaults.
      if (!picker || typeof picker.showModal !== 'function') return;

      this.picker = picker;
      this.pickerError = picker.querySelector('[data-hbs-picker-error]');
      this.pickerConfirm = picker.querySelector('[data-hbs-picker-confirm]');

      picker.querySelectorAll('select[data-hbs-option]').forEach((select) => {
        select.addEventListener('change', () => this.updatePicker());
      });
      picker.querySelector('[data-hbs-picker-close]').addEventListener('click', () => picker.close());
      // A click that lands on the dialog box itself, not its content, is the backdrop.
      picker.addEventListener('click', (event) => {
        if (event.target === picker) picker.close();
      });
      this.pickerConfirm.addEventListener('click', () => {
        const items = Array.from(picker.querySelectorAll('[data-hbs-pick]')).map((input) => ({
          id: Number(input.value),
          quantity: 1
        }));
        this.addBundle(items, this.pickerConfirm, (message) => this.showPickerError(message), () => picker.close());
      });
      this.updatePicker();
    }

    // Resolves each part's option selects to a variant, then sums them. Part
    // prices come from the variant data Liquid rendered in the visitor's
    // currency; formatting uses the shop's own money format so they read
    // exactly like every other price on the page.
    updatePicker() {
      let total = 0;
      let compare = 0;
      let complete = true;

      this.picker.querySelectorAll('[data-hbs-pick-item]').forEach((item) => {
        const pick = item.querySelector('[data-hbs-pick]');
        const data = item.querySelector('[data-hbs-variants]');

        if (data) {
          if (!item.hbsVariants) item.hbsVariants = JSON.parse(data.textContent);
          const chosen = Array.from(item.querySelectorAll('[data-hbs-option]')).map((select) => select.value);
          const variant = item.hbsVariants.find((v) => v.options.every((value, i) => value === chosen[i]));
          const priceLabel = item.querySelector('[data-hbs-pick-price]');
          const ok = !!variant && variant.available;

          priceLabel.classList.toggle('is-unavailable', !ok);
          if (ok) {
            pick.value = variant.id;
            pick.dataset.price = variant.price;
            pick.dataset.compare = variant.compare || 0;
            priceLabel.textContent = this.formatMoney(variant.price);
          } else {
            priceLabel.textContent = variant ? this.picker.dataset.soldOut : this.picker.dataset.unavailable;
            complete = false;
            return;
          }
        }

        const price = Number(pick.dataset.price) || 0;
        total += price;
        compare += Math.max(price, Number(pick.dataset.compare) || 0);
      });

      // With a part unresolved there's no honest total to show.
      this.picker.querySelector('[data-hbs-picker-total]').textContent = complete ? this.formatMoney(total) : '—';
      const del = this.picker.querySelector('[data-hbs-picker-compare]');
      del.hidden = !complete || compare <= total;
      del.textContent = this.formatMoney(compare);
      // A sold-out or non-existent combination can't be added.
      this.pickerConfirm.disabled = !complete;
    }

    formatMoney(cents) {
      const format = typeof theme !== 'undefined' && theme.settings && theme.settings.money_with_currency_format;
      if (format && typeof window.formatMoney === 'function') return window.formatMoney(cents, format);
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency })
        .format(cents / 100);
    }

    onBundleSubmit(event) {
      if (typeof theme === 'undefined' || !theme.routes || !theme.routes.cart_add_url) return;
      event.preventDefault();

      if (this.picker) {
        this.showPickerError(false);
        this.picker.showModal();
        return;
      }

      const button = this.bundleForm.querySelector('button[type="submit"]');
      const items = Array.from(this.bundleForm.querySelectorAll('input[name$="[id]"]')).map((input) => ({
        id: Number(input.value),
        quantity: 1
      }));
      this.addBundle(items, button, (message) => this.showBundleError(message));
    }

    addBundle(items, button, showError, onSuccess) {
      if (button.classList.contains('loading')) return;
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      showError(false);

      fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            showError(response.description || response.message);
            return;
          }
          if (onSuccess) onSuccess();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart:item-added', { product: response.items ? response.items[0] : response });
          }
          const drawer = document.getElementById('Cart-Drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        })
        .catch(() => {
          showError(true);
        })
        .finally(() => {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        });
    }

    showPickerError(message) {
      this.showError(this.pickerError, message);
    }

    showBundleError(message) {
      this.showError(this.bundleError, message);
    }

    showError(element, message) {
      if (!element) return;
      if (!message) {
        element.hidden = true;
        element.textContent = '';
        return;
      }
      element.hidden = false;
      element.textContent = typeof message === 'string'
        ? message
        : 'Something went wrong adding the setup to your cart. Please try again.';
    }
  }

  customElements.define('hotspot-build-sheet', HotspotBuildSheet);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsr-quiz"] && !Shopify.designMode) return;
  try {
    
(function() {
  var TOTAL_STEPS = 5;
  var KEYS = ['experience', 'use_case', 'space', 'portability', 'budget'];
  var WEIGHTS = { budget: 30, space: 25, portability: 20, experience: 15, use_case: 10 };

  function initQuiz(box) {
    var quizId = box.dataset.quiz;
    var dataEl = document.getElementById('nsr-quiz-data-' + quizId);
    if (!dataEl) return;
    var resultsData;
    try { resultsData = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var steps = box.querySelectorAll('[data-quiz-step]');
    var dots = box.querySelectorAll('[data-quiz-progress] .nsr-quiz__progress-dot');
    var stepNumEl = box.querySelector('[data-quiz-step-num]');
    var backBtn = box.querySelector('[data-quiz-back]');
    var navEl = box.querySelector('[data-quiz-nav]');
    var resultEl = box.querySelector('[data-quiz-result]');
    var resultName = box.querySelector('[data-quiz-result-name]');
    var resultPrice = box.querySelector('[data-quiz-result-price]');
    var resultWhy = box.querySelector('[data-quiz-result-why]');
    var resultDims = box.querySelector('[data-quiz-result-dims]');
    var resultImg = box.querySelector('[data-quiz-result-img]');
    var resultLink = box.querySelector('[data-quiz-result-link]');
    var runnerEl = box.querySelector('[data-quiz-runner]');
    var restartBtn = box.querySelector('[data-quiz-restart]');
    var current = 0;
    var answers = {};

    function showStep(i) {
      steps.forEach(function(s, idx) { s.classList.toggle('nsr-quiz__step--active', idx === i); });
      dots.forEach(function(d, idx) {
        d.classList.toggle('nsr-quiz__progress-dot--active', idx === i);
        d.classList.toggle('nsr-quiz__progress-dot--done', idx < i);
      });
      stepNumEl.textContent = i + 1;
      backBtn.disabled = i === 0;
    }

    function scoreResult(r) {
      var total = 0;
      for (var i = 0; i < KEYS.length; i++) {
        var key = KEYS[i];
        var w = WEIGHTS[key];
        var cond = r[key];
        var ans = answers[key];
        if (cond === ans) total += w;
        else if (cond === 'any') total += w * 0.5;
      }
      return total;
    }

    function parseDim(val) {
      if (!val && val !== 0) return null;
      if (typeof val === 'number') return val;
      if (typeof val === 'object' && val !== null && val.value != null) return val.value;
      var n = parseFloat(val);
      return isNaN(n) ? null : n;
    }

    function showResult() {
      var hard = { budget: answers.budget, portability: answers.portability };
      var pool = resultsData.filter(function(r) {
        for (var k in hard) {
          if (r[k] !== hard[k] && r[k] !== 'any') return false;
        }
        return true;
      });
      if (pool.length === 0) pool = resultsData;

      var scored = pool.map(function(r) {
        var origIdx = resultsData.indexOf(r);
        return { idx: origIdx, score: scoreResult(r) };
      });
      scored.sort(function(a, b) { return b.score - a.score; });

      var best = resultsData[scored[0].idx];
      resultName.textContent = best.name;
      resultWhy.textContent = best.why || '';

      if (best.price) {
        resultPrice.textContent = best.price;
        resultPrice.style.display = '';
      } else {
        resultPrice.style.display = 'none';
      }

      var l = parseDim(best.dim_l), h = parseDim(best.dim_h), w = parseDim(best.dim_w);
      if (l || h || w) {
        var parts = [l, w, h].filter(function(v) { return v != null; });
        resultDims.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>' + parts.join(' × ') + ' mm';
      } else {
        resultDims.innerHTML = '';
      }

      if (best.image) {
        resultImg.innerHTML = '<img src="' + best.image + '" alt="' + best.name + '" loading="lazy">';
      } else {
        resultImg.innerHTML = '';
      }

      if (best.link) {
        resultLink.href = best.link;
        resultLink.textContent = (best.link_label || 'Shop this setup') + ' →';
        resultLink.style.display = '';
      } else {
        resultLink.style.display = 'none';
      }

      if (scored.length > 1 && scored[1].score > 0) {
        var runner = resultsData[scored[1].idx];
        var runnerLink = runner.link ? '<a href="' + runner.link + '" class="nsr-quiz__runner-link">Shop ' + runner.name + ' →</a>' : '';
        runnerEl.innerHTML =
          '<div class="nsr-quiz__runner-eyebrow">Also consider</div>' +
          '<div class="nsr-quiz__runner-body">' +
            '<div><div class="nsr-quiz__runner-name">' + runner.name + '</div>' +
            '<div class="nsr-quiz__runner-why">' + (runner.why || '') + '</div></div>' +
            runnerLink +
          '</div>';
      } else {
        runnerEl.innerHTML = '';
      }
    }

    function handleOpt(e) {
      var btn = e.currentTarget;
      var val = btn.dataset.val;
      answers[KEYS[current]] = val;
      btn.closest('.nsr-quiz__opts').querySelectorAll('.nsr-quiz__opt').forEach(function(o) {
        o.classList.remove('nsr-quiz__opt--selected');
      });
      btn.classList.add('nsr-quiz__opt--selected');
      setTimeout(function() {
        if (current < TOTAL_STEPS - 1) {
          current++;
          showStep(current);
        } else {
          steps.forEach(function(s) { s.classList.remove('nsr-quiz__step--active'); });
          navEl.style.display = 'none';
          dots.forEach(function(d) {
            d.classList.add('nsr-quiz__progress-dot--done');
            d.classList.remove('nsr-quiz__progress-dot--active');
          });
          showResult();
          resultEl.classList.add('nsr-quiz__result--active');
        }
      }, 280);
    }

    box.querySelectorAll('.nsr-quiz__opt').forEach(function(btn) {
      btn.addEventListener('click', handleOpt);
    });

    backBtn.addEventListener('click', function() {
      if (current > 0) { current--; showStep(current); }
    });

    restartBtn.addEventListener('click', function() {
      current = 0;
      answers = {};
      box.querySelectorAll('.nsr-quiz__opt').forEach(function(o) { o.classList.remove('nsr-quiz__opt--selected'); });
      resultEl.classList.remove('nsr-quiz__result--active');
      navEl.style.display = '';
      showStep(0);
    });
  }

  function boot() { document.querySelectorAll('[data-quiz]').forEach(initQuiz); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pws-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-pwsben-track]').forEach(function (track) {
        var wrap = track.closest('.pwsben__wrap');
        if (!wrap) return;
        var prevBtn = wrap.querySelector('[data-pwsben-prev]');
        var nextBtn = wrap.querySelector('[data-pwsben-next]');

        function cardStep() {
          var card = track.querySelector('.pwsben__card');
          if (!card) return 300;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
          return card.offsetWidth + gap;
        }

        function updateArrows() {
          if (prevBtn) prevBtn.disabled = track.scrollLeft < 1;
          if (nextBtn) nextBtn.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            track.scrollBy({ left: cardStep(), behavior: 'smooth' });
          });
        }

        track.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pws-fits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.pwsfits').forEach(function (section) {
        var tabs = section.querySelectorAll('[data-pwsfits-tab]');
        var panels = section.querySelectorAll('[data-pwsfits-panel]');
        if (!tabs.length || !panels.length) return;

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var id = tab.getAttribute('data-pwsfits-tab');

            tabs.forEach(function (t) {
              var on = t.getAttribute('data-pwsfits-tab') === id;
              t.classList.toggle('is-active', on);
              t.setAttribute('aria-selected', on ? 'true' : 'false');
            });

            panels.forEach(function (p) {
              p.classList.toggle('is-active', p.getAttribute('data-pwsfits-panel') === id);
            });
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pws-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.pwsrev').forEach(function (section) {
        var track = section.querySelector('[data-pwsrev-track]');
        var arrows = section.querySelectorAll('.pwsrev__arrow');
        if (!track || !arrows.length) return;

        function step() {
          var card = track.querySelector('.pwsrev__card');
          return card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
        }

        function updateArrows() {
          var maxScroll = track.scrollWidth - track.clientWidth - 1;
          arrows.forEach(function (btn) {
            if (btn.getAttribute('data-pwsrev-dir') === 'prev') {
              btn.disabled = track.scrollLeft <= 1;
            } else {
              btn.disabled = track.scrollLeft >= maxScroll;
            }
          });
        }

        arrows.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var dir = btn.getAttribute('data-pwsrev-dir') === 'next' ? 1 : -1;
            track.scrollBy({ left: dir * step(), behavior: 'smooth' });
          });
        });

        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsf-path"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TRIGGER = 0.5;
    var instances = [];
    var ticking = false;

    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    function measure(inst) {
      var timelineRect = inst.timeline.getBoundingClientRect();
      inst.centers = inst.steps.map(function (step) {
        var dot = step.querySelector('.wsfpath__dot');
        var r = (dot || step).getBoundingClientRect();
        return (r.top - timelineRect.top) + r.height / 2;
      });
    }

    function update(inst) {
      var centers = inst.centers;
      if (!centers || centers.length === 0) return;

      var timelineRect = inst.timeline.getBoundingClientRect();
      var playhead = (window.innerHeight * TRIGGER) - timelineRect.top;

      var first = centers[0];
      var last = centers[centers.length - 1];
      var spacing = centers.length > 1 ? (centers[1] - first) : 1;

      var fillPos = clamp(playhead, first, last);
      inst.fill.style.top = first + 'px';
      inst.fill.style.height = (fillPos - first) + 'px';

      inst.steps.forEach(function (step, i) {
        var end = centers[i];
        var start = i > 0 ? centers[i - 1] : (first - spacing);
        var amount = clamp((playhead - start) / (end - start), 0, 1);
        step.style.setProperty('--lit', amount.toFixed(3));
        step.style.setProperty('--reached', (fillPos >= end ? 1 : 0));
      });
    }

    function updateAll() {
      ticking = false;
      instances.forEach(update);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateAll);
      }
    }

    function initPath(section) {
      if (!section) return;
      var timeline = section.querySelector('.wsfpath__timeline');
      var fill = section.querySelector('.wsfpath__rail-fill');
      var steps = Array.prototype.slice.call(section.querySelectorAll('.wsfpath__step'));
      if (!timeline || !fill || !steps.length) return;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      var existing = instances.filter(function (i) { return i.section === section; })[0];
      var inst = existing || { section: section, timeline: timeline, fill: fill, steps: steps };
      if (!existing) instances.push(inst);
      inst.timeline = timeline;
      inst.fill = fill;
      inst.steps = steps;

      section.classList.add('wsfpath--js');
      measure(inst);
      update(inst);
    }

    function initAll() {
      document.querySelectorAll('.wsfpath').forEach(initPath);
    }

    function remeasureAll() {
      instances.forEach(measure);
      updateAll();
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasureAll);
    window.addEventListener('load', remeasureAll);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.wsfpath');
      if (section) initPath(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsf-quiz"] && !Shopify.designMode) return;
  try {
    
(function() {
  var TOTAL_STEPS = 5;
  var KEYS = ['setup', 'torque', 'storage', 'space', 'priority'];
  var WEIGHTS = { torque: 35, priority: 25, storage: 20, space: 12, setup: 8 };

  // Microsoft Clarity arrives as an app embed, so it may not be on the page
  // yet when the quiz scrolls into view (or at all, if the shopper declined
  // tracking). Anything fired before it boots is held in a short-lived queue
  // and flushed once window.clarity appears; after that the queue is dropped
  // so a page without Clarity never keeps polling.
  var clarityQueue = [];
  var clarityWaits = 0;
  var CLARITY_MAX_WAITS = 20; // ~10s at 500ms

  function clarityReady() { return typeof window.clarity === 'function'; }

  function flushClarity() {
    while (clarityQueue.length) {
      var args = clarityQueue.shift();
      try { window.clarity.apply(null, args); } catch (e) {}
    }
  }

  function pumpClarity() {
    if (clarityReady()) { flushClarity(); return; }
    if (clarityWaits++ >= CLARITY_MAX_WAITS) { clarityQueue.length = 0; return; }
    setTimeout(pumpClarity, 500);
  }

  function sendClarity(args) {
    if (clarityReady()) {
      try { window.clarity.apply(null, args); } catch (e) {}
      return;
    }
    clarityQueue.push(args);
    if (clarityWaits === 0) { clarityWaits = 1; setTimeout(pumpClarity, 500); }
  }

  function initQuiz(box) {
    var quizId = box.dataset.quiz;
    var dataEl = document.getElementById('wsfquiz-data-' + quizId);
    if (!dataEl) return;
    var resultsData;
    try { resultsData = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!resultsData.length) return;
    var steps = box.querySelectorAll('[data-quiz-step]');
    var dots = box.querySelectorAll('[data-quiz-progress] .wsfquiz__progress-dot');
    var stepNumEl = box.querySelector('[data-quiz-step-num]');
    var backBtn = box.querySelector('[data-quiz-back]');
    var navEl = box.querySelector('[data-quiz-nav]');
    var resultEl = box.querySelector('[data-quiz-result]');
    var resultName = box.querySelector('[data-quiz-result-name]');
    var resultPrice = box.querySelector('[data-quiz-result-price]');
    var resultWhy = box.querySelector('[data-quiz-result-why]');
    var resultDims = box.querySelector('[data-quiz-result-dims]');
    var resultImg = box.querySelector('[data-quiz-result-img]');
    var resultLink = box.querySelector('[data-quiz-result-link]');
    var runnerEl = box.querySelector('[data-quiz-runner]');
    var restartBtn = box.querySelector('[data-quiz-restart]');
    var current = 0;
    var answers = {};

    // Prefix only exists when Clarity tracking is enabled in the editor;
    // without it every track* call is a no-op.
    var prefix = box.dataset.clarityPrefix || '';
    var fired = {};   // one event per name per page view — keeps the data clean
    var tagged = {};  // same for tags

    function trackEvent(name) {
      if (!prefix || fired[name]) return;
      fired[name] = true;
      sendClarity(['event', prefix + '_' + name]);
    }

    function trackTag(key, value) {
      if (!prefix || !value) return;
      var stamp = key + '=' + value;
      if (tagged[stamp]) return;
      tagged[stamp] = true;
      sendClarity(['set', prefix + '_' + key, String(value)]);
    }

    function showStep(i) {
      steps.forEach(function(s, idx) { s.classList.toggle('wsfquiz__step--active', idx === i); });
      dots.forEach(function(d, idx) {
        d.classList.toggle('wsfquiz__progress-dot--active', idx === i);
        d.classList.toggle('wsfquiz__progress-dot--done', idx < i);
      });
      stepNumEl.textContent = i + 1;
      backBtn.disabled = i === 0;
    }

    function scoreResult(r) {
      var total = 0;
      for (var i = 0; i < KEYS.length; i++) {
        var key = KEYS[i];
        var w = WEIGHTS[key];
        var cond = r[key];
        var ans = answers[key];
        if (cond === ans) total += w;
        else if (cond === 'any') total += w * 0.5;
      }
      return total;
    }

    function showResult() {
      var scored = resultsData.map(function(r, idx) {
        return { idx: idx, score: scoreResult(r) };
      });
      scored.sort(function(a, b) { return b.score - a.score; });

      var best = resultsData[scored[0].idx];
      var bestId = best.clarity_id || 'unknown';
      trackEvent('complete');
      trackEvent('result_' + bestId);
      trackTag('result', bestId);
      resultLink.dataset.clarityResult = bestId;
      resultName.textContent = best.name;
      resultWhy.textContent = best.why || '';

      if (best.price) {
        resultPrice.innerHTML = best.price + (best.was ? '<span class="wsfquiz__result-was">' + best.was + '</span>' : '');
        resultPrice.style.display = '';
      } else {
        resultPrice.style.display = 'none';
      }

      if (best.specs) {
        resultDims.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>' + best.specs;
      } else {
        resultDims.innerHTML = '';
      }

      if (best.image) {
        resultImg.innerHTML = '<img src="' + best.image + '" alt="' + best.name + '" loading="lazy">';
      } else {
        resultImg.innerHTML = '';
      }

      if (best.link) {
        resultLink.href = best.link;
        resultLink.textContent = (best.link_label || 'Shop this stand') + ' →';
        resultLink.style.display = '';
      } else {
        resultLink.style.display = 'none';
      }

      if (scored.length > 1 && scored[1].score > 0) {
        var runner = resultsData[scored[1].idx];
        var runnerId = runner.clarity_id || 'unknown';
        var runnerLink = runner.link ? '<a href="' + runner.link + '" class="wsfquiz__runner-link" data-clarity-result="' + runnerId + '">Shop ' + runner.name + ' →</a>' : '';
        runnerEl.innerHTML =
          '<div class="wsfquiz__runner-eyebrow">Also consider</div>' +
          '<div class="wsfquiz__runner-body">' +
            '<div><div class="wsfquiz__runner-name">' + runner.name + '</div>' +
            '<div class="wsfquiz__runner-why">' + (runner.why || '') + '</div></div>' +
            runnerLink +
          '</div>';
      } else {
        runnerEl.innerHTML = '';
      }
    }

    function handleOpt(e) {
      var btn = e.currentTarget;
      var val = btn.dataset.val;
      var key = KEYS[current];
      answers[key] = val;
      trackEvent('start');
      trackEvent('q' + (current + 1) + '_answered');
      trackTag(key, val);
      btn.closest('.wsfquiz__opts').querySelectorAll('.wsfquiz__opt').forEach(function(o) {
        o.classList.remove('wsfquiz__opt--selected');
      });
      btn.classList.add('wsfquiz__opt--selected');
      setTimeout(function() {
        if (current < TOTAL_STEPS - 1) {
          current++;
          showStep(current);
        } else {
          steps.forEach(function(s) { s.classList.remove('wsfquiz__step--active'); });
          navEl.style.display = 'none';
          dots.forEach(function(d) {
            d.classList.add('wsfquiz__progress-dot--done');
            d.classList.remove('wsfquiz__progress-dot--active');
          });
          showResult();
          resultEl.classList.add('wsfquiz__result--active');
        }
      }, 280);
    }

    box.querySelectorAll('.wsfquiz__opt').forEach(function(btn) {
      btn.addEventListener('click', handleOpt);
    });

    backBtn.addEventListener('click', function() {
      if (current > 0) { trackEvent('back'); current--; showStep(current); }
    });

    resultLink.addEventListener('click', function() {
      var id = resultLink.dataset.clarityResult || 'unknown';
      trackEvent('result_click');
      trackEvent('result_click_' + id);
    });

    // The runner-up card is rendered after the fact, so delegate.
    runnerEl.addEventListener('click', function(e) {
      var link = e.target.closest('.wsfquiz__runner-link');
      if (!link) return;
      trackEvent('runner_click');
      trackEvent('runner_click_' + (link.dataset.clarityResult || 'unknown'));
    });

    restartBtn.addEventListener('click', function() {
      trackEvent('restart');
      current = 0;
      answers = {};
      box.querySelectorAll('.wsfquiz__opt').forEach(function(o) { o.classList.remove('wsfquiz__opt--selected'); });
      resultEl.classList.remove('wsfquiz__result--active');
      navEl.style.display = '';
      showStep(0);
    });

    // Fires once the quiz is genuinely on screen, so the view count is a
    // usable denominator for the start / completion rates above.
    if (prefix && typeof IntersectionObserver === 'function') {
      var viewObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          trackEvent('view');
          viewObserver.disconnect();
        });
      }, { threshold: 0.5 });
      viewObserver.observe(box);
    } else if (prefix) {
      trackEvent('view');
    }
  }

  function boot() { document.querySelectorAll('[data-quiz]').forEach(initQuiz); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
